import script from "./DisplayProfileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayProfileHeader.vue?vue&type=script&setup=true&lang=js"

import "./DisplayProfileHeader.vue?vue&type=style&index=0&id=21fb1154&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21fb1154"]])

export default __exports__